module.exports = __webpack_public_path__ + "img/pagos.c70dd5ce.svg";